export default __webpack_public_path__ + "static/media/NewSnapshot.f231c5f9.png";